import Resource from "./resource.js";
export class LicenseInfo extends Resource {
    constructor(client) {
        super(client, {
            path: "/admin/realms/{realm}/ui-ext/license-module",
            getUrlParams: () => ({
                realm: client.realmName,
            }),
            getBaseUrl: () => client.baseUrl,
        });
    }
    update = this.makeRequest({
        method: "POST",
        path: "/update",
    });
    // Custom update method that supports FormData
    async updateOne(formData) {
        const url = "http://localhost/admin/realms/master/ui-ext/license-module/update";
        console.log("Uploading url:", url);
        try {
            // Send the POST request with FormData
            const response = await fetch(url, {
                method: "POST",
                body: formData, // FormData as the body
                headers: {
                    Accept: "application/json", // Optional: define what kind of response you're expecting
                    // You don't need to manually set the Content-Type header because FormData sets it correctly
                },
            });
            // Check if the response is OK
            if (!response.ok) {
                throw new Error("Failed to upload file");
            }
            // Return the parsed JSON response
            return await response.json(); // or any other form of processing the response
        }
        catch (error) {
            console.error("Error uploading file:", error);
            throw error;
        }
    }
}
